import React, { useState } from "react";

import { Link } from "react-router-dom";
import VideoModal from "../others/VideoModal";

export default function Video() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <section
      id="ComoLoHacemos"
        className="video-promo ptb-100 background-img"
        style={{
          background:
            "url('assets/img/hero-bg-1.jpg') no-repeat center center / cover",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="video-promo-content mt-4 text-center">
                <Link
                  to="#"
                  className="popup-youtube video-play-icon d-inline-block"
                >
                  <span
                    className="ti-control-play"
                    onClick={() => setIsOpen(true)}
                  ></span>
                </Link>
                <h5 className="mt-4 text-white">Mira como lo hacemos</h5>
              </div>
            </div>
          </div>
          <VideoModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </div>
      </section>
    </>
  );
}
